export default __webpack_public_path__ + "static/media/offlinemeeting.34206aef.ico";